export const dateFormat = 'yyyy/MM/dd HH:mm';
export const dateFormatEn = 'MM/dd/yyyy';
export const dateFormatJa = 'yyyy/MM/dd';
